import SFetch from '@app/utils/sfetch'

export default {
  getNotifications({
    companyId = Silverfin.jsonParams.company_id,
    ledgerId = null,
    search,
  }) {
    const params = {
      ...Silverfin.jsonParams,
      company_id: companyId,
      ledger_id: ledgerId,
      search,
      _options: true,
    }

    const url = Silverfin.Routes.company_inbox_index_path(params)
    return SFetch.jsonWithAlert(url)
  },
  getCompanies({ filters, ignoreChecks }) {
    const params = {
      ...Silverfin.jsonParams,
      note_type: filters.noteType,
      tag_ids: filters.tagIds,
      search: filters.search,
      ignore_checks: ignoreChecks,
      _options: true,
    }

    const url = Silverfin.Routes.firm_inbox_index_path(params)

    return SFetch.jsonWithAlert(url)
  },
  toggleReadNotification({ id }) {
    const params = {
      ...Silverfin.jsonParams,
      id,
      _options: true,
    }

    const url = Silverfin.Routes.toggle_read_notification_path(params)

    return SFetch.jsonWithAlert(url, { method: 'PATCH' })
  },
  fetchCompanyUnreadCount({ companyId, search, ignoreChecks }) {
    const params = {
      ...Silverfin.jsonParams,
      company_id: companyId,
      ignore_checks: ignoreChecks,
      search,
      _options: true,
    }

    const url = Silverfin.Routes.unread_count_company_inbox_index_path(params)

    return SFetch.jsonWithAlert(url)
  },
}
